import { LoadingSkeleton } from '@/components/LoadingSkeleton/LoadingSkeleton'

/* Cycled by row so the placeholder list looks like titles of different lengths rather than a grid. */
const rowWidths = [
  { title: '62%', activity: '28%' },
  { title: '45%', activity: '20%' },
  { title: '71%', activity: '33%' },
  { title: '52%', activity: '24%' },
]

/** One placeholder row, laid out like ActivityFeedListItem so the list doesn't shift when the rows arrive. */
export function ActivityFeedSkeleton({ index }: { index: number }) {
  const width = rowWidths[index % rowWidths.length]
  return (
    <div className="flex h-[72px] w-full min-w-0 items-start gap-3 border-b border-brand-neutral-200 px-0.5 py-4">
      <LoadingSkeleton width={18} lineHeight={18} />
      <span className="flex min-w-0 flex-1 flex-col gap-1.5">
        <LoadingSkeleton width={width.title} lineHeight="1.25rem" />
        <LoadingSkeleton width={width.activity} lineHeight="1rem" />
      </span>
    </div>
  )
}
